import { render, staticRenderFns } from "./parent.vue?vue&type=template&id=a32c84d0&scoped=true&"
import script from "./parent.vue?vue&type=script&lang=js&"
export * from "./parent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a32c84d0",
  null
  
)

export default component.exports